import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

type TableHeaderProps = {
  textAlign?: 'left' | 'right';
  width?: string;
};

type CellContentWrapperProps = {
  hasTooltip?: boolean;
  textAlign?: 'left' | 'right';
};
type TableWrapperProps = {
  isTranslationMode?: boolean;
};
export const TableHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;

  h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: ${customPalette.grey.main};
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${customPalette.grey.main};

  &:hover {
    color: #1a202c;
  }
`;

export const TableWrapper = styled.div<TableWrapperProps>`
  background-color: ${customPalette.accent.white};
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  transform: ${({ isTranslationMode }) =>
    isTranslationMode ? 'scale(0.8)' : 'scale(1)'};
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;

  @media (max-width: 850px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      height: 6px;
      background-color: ${customPalette.grey[0]};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${customPalette.grey[200]};
      border-radius: 3px;
    }
  }

  @media (max-width: 850px) and (min-width: 620px) {
    width: 500px;
  }

  @media (max-width: 620px) and (min-width: 400px) {
    width: 350px;
  }

  @media (max-width: 400px) {
    width: 300px;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  @media (max-width: 700px) {
    max-width: 400px;
  }
`;

export const TableHeader = styled.th<TableHeaderProps>`
  padding: 16px;
  text-align: left;
  background-color: ${customPalette.grey[200]};
  color: ${customPalette.grey.main};
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.15px;
  width: ${({ width }) => width || 'auto'};
  min-width: ${({ width }) => width || '120px'};

  &:first-of-type {
    padding-left: 24px;
  }

  &:last-of-type {
    padding-right: 24px;
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${customPalette.grey[200]};

  &:last-child {
    border-bottom: none;
  }

  &:nth-of-type(odd) {
    background-color: ${customPalette.accent.white};
  }

  &:nth-of-type(even) {
    background-color: ${customPalette.grey[0]};
  }
`;

export const CellContentWrapper = styled.div<CellContentWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ textAlign }) =>
    textAlign === 'right' ? 'flex-end' : 'flex-start'};
  gap: 12px;
  width: 100%;
`;

export const TableCell = styled.td<TableHeaderProps>`
  padding: 16px;
  color: ${customPalette.grey.main};
  font-size: 14px;
  border-bottom: 1px solid ${customPalette.grey[200]};
  text-align: ${({ textAlign }) => textAlign || 'left'};

  &:first-of-type {
    padding-left: 24px;
  }

  &:last-of-type {
    padding-right: 24px;
  }
`;

export const EmptyTableMessage = styled.td`
  text-align: center;
  padding: 24px;
  color: ${customPalette.grey.main};
  font-size: 18px;
  background-color: ${customPalette.accent.white};
`;

export const TableFooter = styled.div`
  margin-top: 24px;
  color: ${customPalette.grey.main};
  font-size: 14px;
  line-height: 150%;
`;
